export const FETCH_CLIENT_SCHELUDED_DEACTIVATION = 'FETCH_CLIENT_SCHELUDED_DEACTIVATION';
export const UPDATE_SHOW_MODAL_DEACTIVATION = 'UPDATE_SHOW_MODAL_DEACTIVATION';
